import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://ee5375791c10ada4116071eeb0957fd1@o127356.ingest.us.sentry.io/4509047381688320",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
